import { render, staticRenderFns } from "./boss.vue?vue&type=template&id=849e939a"
import script from "./boss.vue?vue&type=script&lang=js"
export * from "./boss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports